/* @ts-self-types="./rules.d.ts" */

/**
 * Encaisse des Dégâts sur une machine, ou en répare.
 * @param {any} personnage
 * @param {number} index
 * @param {number} subis
 * @returns {any}
 */
export function abimer_une_machine(personnage, index, subis) {
    const ret = wasm.abimer_une_machine(personnage, index, subis);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Accomplit une cérémonie de Rang — ou revient dessus.
 *
 * Le Prérequis narratif est satisfait et la récompense entre au compteur,
 * d'un seul geste comme le livre le fait.
 * @param {any} personnage
 * @param {string} sacrement
 * @returns {any}
 */
export function accomplir_le_sacrement(personnage, sacrement) {
    const ptr0 = passStringToWasm0(sacrement, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.accomplir_le_sacrement(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Achète une Augmentation de Caractéristique ou de Compétence.
 * @param {any} personnage
 * @param {string} quoi
 * @param {string} id
 * @returns {any}
 */
export function acheter_une_augmentation(personnage, quoi, id) {
    const ptr0 = passStringToWasm0(quoi, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.acheter_une_augmentation(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Apprend une Capacité commune, Prérequis vérifiés et XP décomptée.
 * @param {any} personnage
 * @param {string} capacite
 * @returns {any}
 */
export function acheter_une_capacite(personnage, capacite) {
    const ptr0 = passStringToWasm0(capacite, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.acheter_une_capacite(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Se défait d'une Main de Dieu.
 * Achète une Main de Dieu toute faite, au prix du livre en Points d'Influence.
 *
 * Rien ne bouge si la bourse est trop courte : on n'achète pas à crédit.
 * @param {any} personnage
 * @param {string} modele
 * @returns {any}
 */
export function acheter_une_main(personnage, modele) {
    const ptr0 = passStringToWasm0(modele, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.acheter_une_main(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Acquiert ou améliore une Maîtrise d'une Catégorie d'armes.
 * @param {any} personnage
 * @param {string} categorie
 * @returns {any}
 */
export function acheter_une_maitrise(personnage, categorie) {
    const ptr0 = passStringToWasm0(categorie, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.acheter_une_maitrise(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Les 68 profils du bestiaire, pour choisir qui se dresse en face.
 * @returns {any}
 */
export function adversaires_du_bestiaire() {
    const ret = wasm.adversaires_du_bestiaire();
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ajoute une Affliction que le livre ne catalogue pas.
 * @param {any} personnage
 * @param {string} libelle
 * @returns {any}
 */
export function ajouter_affliction(personnage, libelle) {
    const ptr0 = passStringToWasm0(libelle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.ajouter_affliction(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ramasse un objet, ou l'achète en vidant d'autant la bourse.
 * @param {any} personnage
 * @param {string} objet
 * @param {boolean} payer
 * @returns {any}
 */
export function ajouter_objet(personnage, objet, payer) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.ajouter_objet(personnage, ptr0, len0, payer);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Inscrit au sac un objet qu'aucun catalogue ne porte.
 *
 * Le nom, le poids et le prix viennent du joueur : rien n'est deviné.
 * @param {any} personnage
 * @param {string} nom
 * @param {number} encombrement
 * @param {number | null} [prix]
 * @param {string | null} [note]
 * @returns {any}
 */
export function ajouter_objet_libre(personnage, nom, encombrement, prix, note) {
    const ptr0 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(note) ? 0 : passStringToWasm0(note, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.ajouter_objet_libre(personnage, ptr0, len0, encombrement, isLikeNone(prix) ? Number.MAX_SAFE_INTEGER : (prix) >>> 0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Met une machine au garage.
 * @param {any} personnage
 * @param {string} modele
 * @returns {any}
 */
export function ajouter_une_machine(personnage, modele) {
    const ptr0 = passStringToWasm0(modele, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.ajouter_une_machine(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Applique un delta à un compteur et rend le personnage à réenregistrer.
 *
 * Un delta et non une valeur : c'est ce qui permettra au meneur de retirer
 * 5 Points de vie pendant que le joueur en régénère 2, sans que l'un écrase
 * l'autre (ADR-001). Les bornes sont tenues par le moteur, pas par l'écran.
 * @param {any} personnage
 * @param {any} compteur
 * @param {number} delta
 * @returns {any}
 */
export function ajuster_compteur(personnage, compteur, delta) {
    const ret = wasm.ajuster_compteur(personnage, compteur, delta);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Donne, ou retire, de l'argent. Jamais en dessous de zéro.
 * @param {any} personnage
 * @param {bigint} delta
 * @returns {any}
 */
export function ajuster_la_bourse(personnage, delta) {
    const ret = wasm.ajuster_la_bourse(personnage, delta);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce qu'un Alchimiste peut mener, et ce que cela lui coûte.
 * @param {any} personnage
 * @returns {any}
 */
export function alchimie(personnage) {
    const ret = wasm.alchimie(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Change la note d'un objet écrit à la main. Vidée, elle s'efface.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} note
 * @returns {any}
 */
export function annoter_un_objet_libre(personnage, objet, note) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(note, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.annoter_un_objet_libre(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce que vaut chaque Compétence une fois appliqué ce que la fiche sait.
 * @param {any} personnage
 * @returns {any}
 */
export function apercu_des_jets(personnage) {
    const ret = wasm.apercu_des_jets(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce qu'un coup coûterait à ce personnage, sans rien appliquer encore.
 * @param {any} personnage
 * @param {number} degats
 * @param {string} localisation
 * @returns {any}
 */
export function apercu_encaissement(personnage, degats, localisation) {
    const ptr0 = passStringToWasm0(localisation, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.apercu_encaissement(personnage, degats, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Apprivoise un animal, ou renvoie celui qu'on avait.
 * @param {any} personnage
 * @param {string | null} [profil]
 * @returns {any}
 */
export function apprivoiser(personnage, profil) {
    var ptr0 = isLikeNone(profil) ? 0 : passStringToWasm0(profil, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    const ret = wasm.apprivoiser(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Tout ce qui peut entrer dans un sac — armes, armures, objets — pour choisir.
 * @returns {any}
 */
export function articles_du_commerce() {
    const ret = wasm.articles_du_commerce();
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Tout ce qui peut peser sur un Test de cette Compétence.
 *
 * Un seul appel rend la Valeur réelle et la pile de candidats, rangés par
 * famille : ce que la fiche impose, ce que le joueur déclare, ce que le meneur
 * arbitre (ADR-017).
 * @param {any} personnage
 * @param {any} cadre
 * @returns {any}
 */
export function assistant_de_jet(personnage, cadre) {
    const ret = wasm.assistant_de_jet(personnage, cadre);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Attribue une Propriété à un de nos exemplaires sans rien consommer : le
 * geste de l'allié qui travaille avec son propre Matériel.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} propriete
 * @returns {any}
 */
export function attribuer_une_propriete(personnage, objet, propriete) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(propriete, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.attribuer_une_propriete(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Monte une Amélioration de Veredium sur un exemplaire, ou la démonte.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} amelioration
 * @returns {any}
 */
export function basculer_amelioration(personnage, objet, amelioration) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(amelioration, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_amelioration(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ouvre ou referme une blessure à une Localisation.
 * @param {any} personnage
 * @param {string} localisation
 * @param {string} severite
 * @returns {any}
 */
export function basculer_blessure(personnage, localisation, severite) {
    const ptr0 = passStringToWasm0(localisation, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(severite, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_blessure(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Boulonne un équipement sur une machine, ou le démonte.
 * @param {any} personnage
 * @param {number} index
 * @param {string} equipement
 * @returns {any}
 */
export function basculer_equipement_de_machine(personnage, index, equipement) {
    const ptr0 = passStringToWasm0(equipement, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_equipement_de_machine(personnage, index, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Pose ou retire une Folie du catalogue.
 * @param {any} personnage
 * @param {string} folie
 * @returns {any}
 */
export function basculer_folie(personnage, folie) {
    const ptr0 = passStringToWasm0(folie, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_folie(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Greffe, ou retire, une pièce de Prouesse.
 * @param {any} personnage
 * @param {string} greffe
 * @returns {any}
 */
export function basculer_greffe(personnage, greffe) {
    const ptr0 = passStringToWasm0(greffe, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_greffe(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Coche, ou décoche, un Prérequis que seule la table peut trancher.
 * @param {any} personnage
 * @param {string} texte
 * @returns {any}
 */
export function basculer_narratif(personnage, texte) {
    const ptr0 = passStringToWasm0(texte, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_narratif(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Pose ou retire un Statut, et rend le personnage à réenregistrer.
 * @param {any} personnage
 * @param {string} statut
 * @returns {any}
 */
export function basculer_statut(personnage, statut) {
    const ptr0 = passStringToWasm0(statut, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.basculer_statut(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ouvre une blessure à une Localisation — un coup encaissé, pas une correction.
 * @param {any} personnage
 * @param {string} localisation
 * @param {string} severite
 * @returns {any}
 */
export function blesser(personnage, localisation, severite) {
    const ptr0 = passStringToWasm0(localisation, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(severite, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.blesser(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Charge et valide le référentiel embarqué.
 *
 * Rend le nombre de catalogues chargés, ou une erreur lisible. Le premier
 * appel fait le travail ; les suivants sont gratuits.
 */
export function charger_referentiel() {
    const ret = wasm.charger_referentiel();
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Charge une Main de Dieu, ou en dépense une munition.
 *
 * Le prix ne se décompte pas — le livre les vend au lot, en PI ou en livres,
 * et la table tranche. Ce qui se tient ici, c'est le compte.
 * @param {any} personnage
 * @param {number} index
 * @param {number} delta
 * @returns {any}
 */
export function charger_une_main(personnage, index, delta) {
    const ret = wasm.charger_une_main(personnage, index, delta);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Chiffre un objet inventé à la table. Il ne pèse que porté.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} cible
 * @param {string} id
 * @param {number} valeur
 * @returns {any}
 */
export function chiffrer_un_objet_libre(personnage, objet, cible, id, valeur) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(cible, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.chiffrer_un_objet_libre(personnage, ptr0, len0, ptr1, len1, ptr2, len2, valeur);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Chiffre une Affliction écrite par la table : « −30 en Séduction ».
 *
 * `cible` vaut `tous`, `famille`, `competence` ou `caracteristique`.
 * @param {any} personnage
 * @param {number} index
 * @param {string} cible
 * @param {string} id
 * @param {number} valeur
 * @returns {any}
 */
export function chiffrer_une_affliction(personnage, index, cible, id, valeur) {
    const ptr0 = passStringToWasm0(cible, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.chiffrer_une_affliction(personnage, index, ptr0, len0, ptr1, len1, valeur);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Choisit un élément d'Union, ou y renonce.
 * @param {any} personnage
 * @param {string} element
 * @returns {any}
 */
export function choisir_un_element(personnage, element) {
    const ptr0 = passStringToWasm0(element, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.choisir_un_element(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce qu'une créature sait faire, et avec quelle Valeur.
 * @param {string} profil
 * @returns {any}
 */
export function competences_d_un_adversaire(profil) {
    const ptr0 = passStringToWasm0(profil, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.competences_d_un_adversaire(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Les résultats qu'offre un Jet chanceux, sans doublon.
 *
 * Le livre fait lancer deux D100 et composer un résultat avec la dizaine de
 * l'un et l'unité de l'autre. Les deux dés viennent de l'appelant ; le choix
 * entre les compositions revient au joueur.
 * @param {number} premier
 * @param {number} second
 * @returns {Uint8Array}
 */
export function compositions_chanceuses(premier, second) {
    const ret = wasm.compositions_chanceuses(premier, second);
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * Corrige la valeur d'un chiffre posé sur une Affliction. Zéro est refusé.
 * @param {any} personnage
 * @param {number} index
 * @param {number} position
 * @param {number} valeur
 * @returns {any}
 */
export function corriger_un_chiffre_d_affliction(personnage, index, position, valeur) {
    const ret = wasm.corriger_un_chiffre_d_affliction(personnage, index, position, valeur);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Corrige la valeur d'un chiffre posé sur un objet écrit à la main.
 * @param {any} personnage
 * @param {string} objet
 * @param {number} position
 * @param {number} valeur
 * @returns {any}
 */
export function corriger_un_chiffre_d_objet(personnage, objet, position, valeur) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.corriger_un_chiffre_d_objet(personnage, ptr0, len0, position, valeur);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Fait aboutir la feuille de Création.
 *
 * Rend le personnage à enregistrer, ou la liste de ce qui l'en empêche : le
 * refus est une valeur, pas une exception, sans quoi les anomalies se
 * perdraient en route.
 * @param {any} feuille
 * @returns {any}
 */
export function creer_personnage(feuille) {
    const ret = wasm.creer_personnage(feuille);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * @param {any} personnage
 * @param {number} index
 * @returns {any}
 */
export function defaire_une_main(personnage, index) {
    const ret = wasm.defaire_une_main(personnage, index);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Prépare le module. À appeler une fois, avant tout le reste.
 *
 * Sans le crochet à paniques, une erreur Rust se manifeste dans la console du
 * navigateur par un « unreachable executed » sans pile d'appel.
 */
export function demarrer() {
    wasm.demarrer();
}

/**
 * Désigne un paquet favori — celui qui porte un Joker — ou le retire.
 * @param {any} personnage
 * @param {string} sphere
 * @returns {any}
 */
export function designer_un_favori(personnage, sphere) {
    const ptr0 = passStringToWasm0(sphere, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.designer_un_favori(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Les panneaux de l'écran Perso que cette fiche a le droit d'ouvrir.
 * @param {any} personnage
 * @returns {any}
 */
export function domaines(personnage) {
    const ret = wasm.domaines(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Inscrit un Rituel que le meneur a écrit.
 * @param {any} personnage
 * @param {string} nom
 * @param {string} cercle
 * @param {string | null | undefined} duree
 * @param {string} effet
 * @returns {any}
 */
export function ecrire_un_rituel(personnage, nom, cercle, duree, effet) {
    const ptr0 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(cercle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(duree) ? 0 : passStringToWasm0(duree, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(effet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.ecrire_un_rituel(personnage, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Efface un chiffre d'une Affliction, par sa place dans la liste.
 * @param {any} personnage
 * @param {number} index
 * @param {number} position
 * @returns {any}
 */
export function effacer_un_chiffre_d_affliction(personnage, index, position) {
    const ret = wasm.effacer_un_chiffre_d_affliction(personnage, index, position);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Efface un chiffre d'un objet inventé, par sa place dans la liste.
 * @param {any} personnage
 * @param {string} objet
 * @param {number} position
 * @returns {any}
 */
export function effacer_un_chiffre_d_objet(personnage, objet, position) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.effacer_un_chiffre_d_objet(personnage, ptr0, len0, position);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Efface un Rituel de la table.
 * @param {any} personnage
 * @param {number} index
 * @returns {any}
 */
export function effacer_un_rituel(personnage, index) {
    const ret = wasm.effacer_un_rituel(personnage, index);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce que le personnage traîne d'abîmé, et de quoi le réparer.
 * @param {any} personnage
 * @returns {any}
 */
export function equipements_abimes(personnage) {
    const ret = wasm.equipements_abimes(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * L'état de la feuille : soldes, plafonds, aperçu de la fiche et anomalies.
 *
 * Un seul franchissement de la frontière par frappe de touche, plutôt que
 * huit : la liste d'anomalies arrive **avec** les soldes, donc l'écran montre
 * d'un coup ce qui cloche et ce qu'il reste à dépenser.
 * @param {any} feuille
 * @returns {any}
 */
export function etat_de_creation(feuille) {
    const ret = wasm.etat_de_creation(feuille);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * La fiche complète d'un personnage enregistré, en un seul appel.
 *
 * Valeurs réelles, huit dérivées, noms imprimés, inventaire résolu : tout ce
 * qu'un écran affiche arrive d'un coup (ADR-017). Rien de tout cela n'est
 * enregistré — seules les valeurs brutes le sont.
 * @param {any} personnage
 * @returns {any}
 */
export function fiche_de_personnage(personnage) {
    const ret = wasm.fiche_de_personnage(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Forge une Main de Dieu du livre, sur son Plan.
 *
 * Le matériel part que le Test réussisse ou non ; l'arme n'arrive qu'en cas
 * de réussite. Un sac trop maigre refuse tout.
 * @param {any} personnage
 * @param {string} modele
 * @param {boolean} reussi
 * @returns {any}
 */
export function forger_une_main(personnage, modele, reussi) {
    const ptr0 = passStringToWasm0(modele, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.forger_une_main(personnage, ptr0, len0, reussi);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Inscrit une Main de Dieu que le joueur et le meneur ont dessinée ensemble.
 *
 * Le livre donne sept exemples et la règle de fabrication : rien n'oblige à
 * s'en tenir aux sept. Rien n'est deviné — tout vient de la table.
 * @param {any} personnage
 * @param {string} nom
 * @param {number} niveau
 * @param {string} competence
 * @param {bigint | null | undefined} degats
 * @param {boolean} plus_force_de_frappe
 * @param {string | null | undefined} portee
 * @param {string | null | undefined} special
 * @param {string | null | undefined} tribut
 * @param {boolean} reussi
 * @returns {any}
 */
export function forger_une_main_libre(personnage, nom, niveau, competence, degats, plus_force_de_frappe, portee, special, tribut, reussi) {
    const ptr0 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(competence, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(portee) ? 0 : passStringToWasm0(portee, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    var ptr3 = isLikeNone(special) ? 0 : passStringToWasm0(special, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len3 = WASM_VECTOR_LEN;
    var ptr4 = isLikeNone(tribut) ? 0 : passStringToWasm0(tribut, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len4 = WASM_VECTOR_LEN;
    const ret = wasm.forger_une_main_libre(personnage, ptr0, len0, niveau, ptr1, len1, !isLikeNone(degats), isLikeNone(degats) ? BigInt(0) : degats, plus_force_de_frappe, ptr2, len2, ptr3, len3, ptr4, len4, reussi);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Les paquets du Cartomancien : pioche, Défausse, favoris, éléments, limite.
 * @param {any} personnage
 * @returns {any}
 */
export function grimoire(personnage) {
    const ret = wasm.grimoire(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce que le Compagnon subit, apprend, ou devient.
 *
 * `quoi` vaut `nom`, `pv`, `affinite`, `ordre` ou `reflexe`.
 * @param {any} personnage
 * @param {string} quoi
 * @param {string} texte
 * @param {number} valeur
 * @returns {any}
 */
export function instruire_le_compagnon(personnage, quoi, texte, valeur) {
    const ptr0 = passStringToWasm0(quoi, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(texte, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.instruire_le_compagnon(personnage, ptr0, len0, ptr1, len1, valeur);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Un état des lieux du référentiel, pour vérifier d'un coup d'œil que le
 * module et ses données sont bien arrivés ensemble.
 * @returns {any}
 */
export function inventaire() {
    const ret = wasm.inventaire();
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Enregistre une carte piochée et ce qu'elle est devenue.
 *
 * `issue` vaut `defaussee` (réussite, échec, ou renoncement), `revient`
 * (réussite critique) ou `echec_critique`.
 * @param {any} personnage
 * @param {string} sphere
 * @param {string} carte
 * @param {string} issue
 * @param {boolean} hors_limite
 * @returns {any}
 */
export function jouer_une_carte(personnage, sphere, carte, issue, hors_limite) {
    const ptr0 = passStringToWasm0(sphere, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(carte, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(issue, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.jouer_une_carte(personnage, ptr0, len0, ptr1, len1, ptr2, len2, hors_limite);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * La Localisation qu'un 1D100 désigne sur la silhouette.
 * @param {number} d100
 * @returns {any}
 */
export function localisation_touchee(d100) {
    const ret = wasm.localisation_touchee(d100);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Le garage : ce que le personnage pilote, et ce qu'il pourrait piloter.
 * @param {any} personnage
 * @returns {any}
 */
export function machines(personnage) {
    const ret = wasm.machines(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce qu'une carte ouvre, Sphère par Sphère.
 *
 * La carte est tirée par le joueur : le moteur ne la tire pas à sa place.
 * @param {string} carte
 * @returns {any}
 */
export function magie(carte) {
    const ptr0 = passStringToWasm0(carte, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.magie(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce qu'une carte ouvre à ce personnage-ci : sans les Sorts d'Union des
 * éléments qu'il n'a pas choisis.
 * @param {any} personnage
 * @param {string} carte
 * @returns {any}
 */
export function magie_du_personnage(personnage, carte) {
    const ptr0 = passStringToWasm0(carte, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.magie_du_personnage(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Les Mains de Dieu forgées, les sept Plans du livre, et ce que forger exige.
 * @param {any} personnage
 * @returns {any}
 */
export function mains_de_dieu(personnage) {
    const ret = wasm.mains_de_dieu(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Le Matériel d'amélioration qui reste au sac.
 * @param {any} personnage
 * @returns {any}
 */
export function materiel_d_amelioration(personnage) {
    const ret = wasm.materiel_d_amelioration(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Combien de Matériels de réparation restent dans les contenants portés.
 * @param {any} personnage
 * @returns {number}
 */
export function materiel_de_reparation(personnage) {
    const ret = wasm.materiel_de_reparation(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ret[0] >>> 0;
}

/**
 * Une nouvelle journée en jeu : la limite de pioche repart de zéro.
 * @param {any} personnage
 * @returns {any}
 */
export function nouvelle_journee(personnage) {
    const ret = wasm.nouvelle_journee(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Résout un Test opposé : le jet du joueur, celui d'en face, et l'issue.
 *
 * Les deux dés viennent de l'appelant. Le livre laisse au meneur le choix de
 * la Compétence opposante : elle est déclarée, jamais devinée.
 * @param {any} personnage
 * @param {any} demande
 * @param {any} adverse
 * @returns {any}
 */
export function opposer_un_jet(personnage, demande, adverse) {
    const ret = wasm.opposer_un_jet(personnage, demande, adverse);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Pose un Renforcement sur un exemplaire, ou l'en retire.
 *
 * `sens` vaut `1` pour octroyer et `-1` pour retirer : le livre laisse le
 * choix, et ne tranche pas à la place du joueur.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} source
 * @param {number} sens
 * @returns {any}
 */
export function poser_un_renfort(personnage, objet, source, sens) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(source, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.poser_un_renfort(personnage, ptr0, len0, ptr1, len1, sens);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce que le personnage peut s'offrir avec son Expérience.
 * @param {any} personnage
 * @returns {any}
 */
export function progression(personnage) {
    const ret = wasm.progression(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Franchit un Rang, une fois ses Prérequis réunis.
 * @param {any} personnage
 * @param {string} noeud
 * @returns {any}
 */
export function promouvoir(personnage, noeud) {
    const ptr0 = passStringToWasm0(noeud, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.promouvoir(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce que l'armure portée protège, Localisation par Localisation.
 * @param {any} personnage
 * @returns {any}
 */
export function protections_du_personnage(personnage) {
    const ret = wasm.protections_du_personnage(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Ce que la Prouesse a greffé, ce que ça donne, et ce que ça coûte.
 * @param {any} personnage
 * @returns {any}
 */
export function prouesse(personnage) {
    const ret = wasm.prouesse(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Reprend une carte de la Défausse : `influence`, `livres` ou `offerte`.
 * @param {any} personnage
 * @param {string} sphere
 * @param {string} carte
 * @param {string} moyen
 * @returns {any}
 */
export function racheter_une_carte(personnage, sphere, carte, moyen) {
    const ptr0 = passStringToWasm0(sphere, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(carte, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(moyen, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.racheter_une_carte(personnage, ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Équipe un objet, le range dans le sac, ou le laisse à la maison.
 *
 * `ou` vaut `equipe`, `sac` ou `laisse`. Seule une armure équipée protège ;
 * seul ce qu'on emporte pèse dans l'Encombrement.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} ou
 * @returns {any}
 */
export function ranger_objet(personnage, objet, ou) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(ou, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.ranger_objet(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Tout ce dont l'écran de Création a besoin, une fois pour toutes.
 *
 * Sept Régions, huit Classes, 41 Compétences, 47 Capacités et les deux
 * barèmes : autant les faire traverser d'un coup plutôt qu'à la demande.
 * @returns {any}
 */
export function referentiel_de_creation() {
    const ret = wasm.referentiel_de_creation();
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * La Région que désigne un D100. Le dé est lancé par l'appelant.
 * @param {number} d100
 * @returns {string | undefined}
 */
export function region_tiree(d100) {
    const ret = wasm.region_tiree(d100);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    let v1;
    if (ret[0] !== 0) {
        v1 = getStringFromWasm0(ret[0], ret[1]);
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v1;
}

/**
 * Les Renforcements qu'on peut poser sur un exemplaire, et ce qui les refuse.
 * @param {any} personnage
 * @param {string} objet
 * @returns {any}
 */
export function renforts_possibles(personnage, objet) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.renforts_possibles(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Corrige le libellé d'une Affliction écrite par la table. Ses chiffres restent.
 * @param {any} personnage
 * @param {number} index
 * @param {string} libelle
 * @returns {any}
 */
export function renommer_affliction(personnage, index, libelle) {
    const ptr0 = passStringToWasm0(libelle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.renommer_affliction(personnage, index, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Corrige le nom d'un objet écrit à la main.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} nom
 * @returns {any}
 */
export function renommer_un_objet_libre(personnage, objet, nom) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.renommer_un_objet_libre(personnage, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Baptise une machine, ou lui rend son nom de modèle.
 * @param {any} personnage
 * @param {number} index
 * @param {string} nom
 * @returns {any}
 */
export function renommer_une_machine(personnage, index, nom) {
    const ptr0 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.renommer_une_machine(personnage, index, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Baptise une Main de Dieu, ou lui rend son nom de Plan.
 * @param {any} personnage
 * @param {number} index
 * @param {string} nom
 * @returns {any}
 */
export function renommer_une_main(personnage, index, nom) {
    const ptr0 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.renommer_une_main(personnage, index, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Reprend un objet déjà écrit à la main : un de plus sur la pile.
 * @param {any} personnage
 * @param {string} nom
 * @returns {any}
 */
export function reprendre_un_objet_libre(personnage, nom) {
    const ptr0 = passStringToWasm0(nom, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.reprendre_un_objet_libre(personnage, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Résout un jet et rend le détail du calcul. Le dé est lancé par l'appelant.
 * @param {any} personnage
 * @param {any} demande
 * @returns {any}
 */
export function resoudre_jet(personnage, demande) {
    const ret = wasm.resoudre_jet(personnage, demande);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Retire l'Affliction à cette place dans la liste.
 * @param {any} personnage
 * @param {number} index
 * @returns {any}
 */
export function retirer_affliction(personnage, index) {
    const ret = wasm.retirer_affliction(personnage, index);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Se défait d'un objet — jeté, ou vendu à la moitié de son prix.
 * @param {any} personnage
 * @param {string} objet
 * @param {boolean} vendre
 * @returns {any}
 */
export function retirer_objet(personnage, objet, vendre) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.retirer_objet(personnage, ptr0, len0, vendre);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Retire une machine du garage.
 * @param {any} personnage
 * @param {number} index
 * @returns {any}
 */
export function retirer_une_machine(personnage, index) {
    const ret = wasm.retirer_une_machine(personnage, index);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Tout ce que l'écran du Sac affiche : les lignes, la bourse, la charge.
 * @param {any} personnage
 * @returns {any}
 */
export function sac(personnage) {
    const ret = wasm.sac(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Applique un coup encaissé : les PV, la blessure, et l'armure qui s'abîme.
 *
 * Un seul appel plutôt que trois : c'est le livre qui enchaîne ces trois
 * conséquences, et chacune a sa condition.
 * @param {any} personnage
 * @param {number} subis
 * @param {string} localisation
 * @param {boolean} critique
 * @param {boolean} visee
 * @returns {any}
 */
export function subir_un_coup(personnage, subis, localisation, critique, visee) {
    const ptr0 = passStringToWasm0(localisation, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.subir_un_coup(personnage, subis, ptr0, len0, critique, visee);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Tente une amélioration d'Artisanat : le Matériel part, réussie ou non.
 * @param {any} personnage
 * @param {string} objet
 * @param {string} propriete
 * @param {boolean} reussi
 * @returns {any}
 */
export function tenter_une_amelioration(personnage, objet, propriete, reussi) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(propriete, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.tenter_une_amelioration(personnage, ptr0, len0, ptr1, len1, reussi);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Tente une réparation : un Matériel consommé, et l'objet remis en état si le
 * Test d'Artisanat a réussi.
 * @param {any} personnage
 * @param {string} objet
 * @param {boolean} reussi
 * @returns {any}
 */
export function tenter_une_reparation(personnage, objet, reussi) {
    const ptr0 = passStringToWasm0(objet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.tenter_une_reparation(personnage, ptr0, len0, reussi);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Le verdict du domaine sur un D100 au Tableau des Capacités aléatoires.
 *
 * Le domaine ne relance pas : il dit qu'il faut relancer, et l'appelant
 * relance avec son propre dé.
 * @param {any} feuille
 * @param {number} d100
 * @returns {any}
 */
export function tirage_de_capacite(feuille, d100) {
    const ret = wasm.tirage_de_capacite(feuille, d100);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Le Compagnon du Rôdeur, et les animaux qu'on peut apprivoiser.
 * @param {any} personnage
 * @returns {any}
 */
export function vie_sauvage(personnage) {
    const ret = wasm.vie_sauvage(personnage);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_408e67f47ca7b58b: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_Number_3890faa6d3ff057d: function(arg0) {
            const ret = Number(arg0);
            return ret;
        },
        __wbg_String_8564e559799eccda: function(arg0, arg1) {
            const ret = String(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_bigint_get_as_i64_c4ecf48528083721: function(arg0, arg1) {
            const v = arg1;
            const ret = typeof(v) === 'bigint' ? v : undefined;
            getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_boolean_get_c9c83ebd41b34df3: function(arg0) {
            const v = arg0;
            const ret = typeof(v) === 'boolean' ? v : undefined;
            return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_a57024b9c6e4a48b: function(arg0, arg1) {
            const ret = debugString(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_in_ac983077f137f2e6: function(arg0, arg1) {
            const ret = arg0 in arg1;
            return ret;
        },
        __wbg___wbindgen_is_bigint_8ffbbef442139384: function(arg0) {
            const ret = typeof(arg0) === 'bigint';
            return ret;
        },
        __wbg___wbindgen_is_function_5e4570eb24ffa122: function(arg0) {
            const ret = typeof(arg0) === 'function';
            return ret;
        },
        __wbg___wbindgen_is_object_a2790eb24c211ea0: function(arg0) {
            const val = arg0;
            const ret = typeof(val) === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_e6f02f0ea5f20a32: function(arg0) {
            const ret = typeof(arg0) === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_6cff064c44e0d823: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_eq_0a18949a61670320: function(arg0, arg1) {
            const ret = arg0 === arg1;
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_acf2776254a8d832: function(arg0, arg1) {
            const ret = arg0 == arg1;
            return ret;
        },
        __wbg___wbindgen_number_get_136b9679cab35cfb: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'number' ? obj : undefined;
            getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_d154f1e671052120: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_bb96b2010945f0bc: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_call_1c5886ab9c57d1c7: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments); },
        __wbg_done_669171204c3dcae2: function(arg0) {
            const ret = arg0.done;
            return ret;
        },
        __wbg_entries_7774d489e1da5f4f: function(arg0) {
            const ret = Object.entries(arg0);
            return ret;
        },
        __wbg_error_757e9472f8410341: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.error(getStringFromWasm0(arg0, arg1));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_get_c0c8f8d7da0c03dd: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_d173c0308df22d37: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.get(arg0, arg1);
            return ret;
        }, arguments); },
        __wbg_get_unchecked_e20b893aeafc3fca: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_with_ref_key_6412cf3094599694: function(arg0, arg1) {
            const ret = arg0[arg1];
            return ret;
        },
        __wbg_instanceof_ArrayBuffer_993d02d2d254cad1: function(arg0) {
            let result;
            try {
                result = arg0 instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_f935dbb0aa7cdeed: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_6339f732981044bf: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_isSafeInteger_f3d6cd19ccfe4512: function(arg0) {
            const ret = Number.isSafeInteger(arg0);
            return ret;
        },
        __wbg_iterator_5cebbb86e33c6dd6: function() {
            const ret = Symbol.iterator;
            return ret;
        },
        __wbg_length_36bd29c6848c2144: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_ecfa2c63d3d0d82c: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_new_116be93542d39019: function() {
            const ret = new Array();
            return ret;
        },
        __wbg_new_227d7c05414eb861: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_new_77cc4f4f472aeb81: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_cdf041679ded4c5f: function() {
            const ret = new Map();
            return ret;
        },
        __wbg_new_ebe3e0f6837f0879: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_next_42cf16ee0dafc9e2: function() { return handleError(function (arg0) {
            const ret = arg0.next();
            return ret;
        }, arguments); },
        __wbg_next_8f26b64fa5e9f64b: function(arg0) {
            const ret = arg0.next;
            return ret;
        },
        __wbg_prototypesetcall_de8e0d9553586985: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_set_014226dfeca53178: function(arg0, arg1, arg2) {
            const ret = arg0.set(arg1, arg2);
            return ret;
        },
        __wbg_set_6be42768c690e380: function(arg0, arg1, arg2) {
            arg0[arg1] = arg2;
        },
        __wbg_set_a80955eb93b145c6: function(arg0, arg1, arg2) {
            arg0[arg1 >>> 0] = arg2;
        },
        __wbg_stack_3b0d974bbf31e44f: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_value_1e2369fab29b420e: function(arg0) {
            const ret = arg0.value;
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000002: function(arg0) {
            // Cast intrinsic for `I64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000003: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000004: function(arg0) {
            // Cast intrinsic for `U64 -> Externref`.
            const ret = BigInt.asUintN(64, arg0);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./rules_bg.js": import0,
    };
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (!module.ok) {
            throw new Error(`failed to fetch Wasm: ${module.status} ${module.statusText} fetching '${module.url}'`);
        }

        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('rules_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
